import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/navigate_left_32px.png'
import _imports_1 from '@/assets/icons/navigate_right_black_24px.png'
import _imports_2 from '@/assets/icons/white_arrow_right_24px.png'
import _imports_3 from '@/assets/icons/white_publish_24px.png'
import _imports_4 from '@/assets/icons/white_check_2_32px.png'
import _imports_5 from '@/assets/icons/timer_20px.png'
import _imports_6 from '@/assets/icons/white_ai_assist_24dp.png'
import _imports_7 from '@/assets/icons/white_ready_32px.png'
import _imports_8 from '@/assets/icons/white_warning_32px.png'


const _withScopeId = n => (_pushScopeId("data-v-559c32de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body-width" }
const _hoisted_2 = { class: "page-head-menu" }
const _hoisted_3 = { class: "page-back" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icons_navigate_left_32px",
  class: "icon-32"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = {
  key: 0,
  class: "pr-10 fc-primary"
}
const _hoisted_9 = {
  key: 1,
  class: "pr-10"
}
const _hoisted_10 = { class: "ml-auto flex-center" }
const _hoisted_11 = {
  key: 0,
  src: _imports_1,
  class: "icon-24 ml-12",
  alt: "navigate_right_black_24px"
}
const _hoisted_12 = {
  key: 1,
  src: _imports_2,
  class: "icon-24 ml-12",
  alt: "icons_white_arrow_right_24px"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-24 flex-mid" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "icon-24",
    alt: "icons_white_publish_24px"
  })
], -1))
const _hoisted_14 = {
  key: 0,
  src: _imports_1,
  class: "icon-24 ml-12",
  alt: "navigate_right_black_24px"
}
const _hoisted_15 = {
  key: 1,
  src: _imports_2,
  class: "icon-24 ml-12",
  alt: "icons_white_arrow_right_24px"
}
const _hoisted_16 = {
  key: 0,
  src: _imports_1,
  class: "icon-24 ml-12",
  alt: "navigate_right_black_24px"
}
const _hoisted_17 = {
  key: 1,
  src: _imports_2,
  class: "icon-24 ml-12",
  alt: "icons_white_arrow_right_24px"
}
const _hoisted_18 = { class: "ml-24 flex-mid" }
const _hoisted_19 = {
  key: 5,
  class: "ml-16 btn btn-50 btn-DEDEDE"
}
const _hoisted_20 = { class: "mr-16" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#aaa",
    d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      dur: "1s",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })
  ])
], -1))
const _hoisted_22 = { class: "detail p-40" }
const _hoisted_23 = {
  class: "step",
  style: {}
}
const _hoisted_24 = { class: "flex-mid active" }
const _hoisted_25 = { class: "step-container center" }
const _hoisted_26 = {
  key: 0,
  class: "flex-mid"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "icon-24",
  alt: "icons_white_check_2_32px"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_31 = { class: "step-container center" }
const _hoisted_32 = {
  key: 0,
  class: "flex-mid"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "icon-24",
  alt: "icons_white_check_2_32px"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_37 = { class: "step-container center" }
const _hoisted_38 = {
  key: 0,
  class: "flex-mid"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "icon-24",
  alt: "icons_white_check_2_32px"
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_43 = { class: "step-container center" }
const _hoisted_44 = {
  class: "",
  style: {"padding":"0 6.4rem 6.4rem"}
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = {
  key: 1,
  class: "section-box-container"
}
const _hoisted_48 = { class: "title" }
const _hoisted_49 = { class: "time flex-center" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "icon-16 mr-7 opa-05",
  alt: "icons_timer_20px"
}, null, -1))
const _hoisted_51 = { class: "description" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ", -1))
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "flex footer" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "true" }
const _hoisted_57 = { class: "flex-center" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "icon false",
  alt: "icons_white_block_32px"
}, null, -1))
const _hoisted_59 = { class: "false" }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = {
  key: 0,
  class: "box-card p-24 mt-24"
}
const _hoisted_62 = { class: "fs-16 fw-700" }
const _hoisted_63 = { class: "fs-14 mt-12" }
const _hoisted_64 = { class: "mt-32 flex-center" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "icons_white_ai_assist_24dp",
  class: "mr-16"
}, null, -1))
const _hoisted_66 = { class: "" }
const _hoisted_67 = {
  key: 1,
  ref: "top_of_setup_card"
}
const _hoisted_68 = {
  key: 2,
  class: "box-step-three box-card p-24 mt-24"
}
const _hoisted_69 = { class: "title" }
const _hoisted_70 = { class: "description" }
const _hoisted_71 = { class: "flex-center" }
const _hoisted_72 = {
  key: 0,
  class: "btn btn-50 x-btn-primary max-m-mt-24 checkbox-set-up",
  style: {"background-color":"#dedede","cursor":"wait"}
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      dur: "1s",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })
  ])
], -1))
const _hoisted_74 = { class: "label mr-auto" }
const _hoisted_75 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "icon-24",
  alt: "icons_white_ready_32px"
}, null, -1))
const _hoisted_77 = { class: "label" }
const _hoisted_78 = {
  key: 1,
  class: "flex-center"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "icon-24",
  alt: "icons_white_warning_32px"
}, null, -1))
const _hoisted_80 = {
  key: 0,
  class: "label"
}
const _hoisted_81 = {
  key: 1,
  class: "label"
}
const _hoisted_82 = {
  key: 3,
  class: "box-step-three box-card p-24 mt-24"
}
const _hoisted_83 = { class: "title" }
const _hoisted_84 = { class: "description" }
const _hoisted_85 = { class: "flex-center" }
const _hoisted_86 = {
  key: 0,
  class: "btn btn-50 x-btn-primary max-m-mt-24 checkbox-set-up",
  style: {"background-color":"#dedede","cursor":"wait"}
}
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  version: "1.1",
  id: "L9",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 100 100",
  "enable-background": "new 0 0 0 0",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
  }, [
    /*#__PURE__*/_createElementVNode("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      dur: "1s",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })
  ])
], -1))
const _hoisted_88 = { class: "label mr-auto" }
const _hoisted_89 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "icon-24",
  alt: "icons_white_ready_32px"
}, null, -1))
const _hoisted_91 = { class: "label" }
const _hoisted_92 = {
  key: 1,
  class: "flex-center"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "icon-24",
  alt: "icons_white_warning_32px"
}, null, -1))
const _hoisted_94 = {
  key: 0,
  class: "label"
}
const _hoisted_95 = {
  key: 1,
  class: "label"
}
const _hoisted_96 = {
  key: 4,
  class: "box-step-three box-card p-24 mt-24"
}
const _hoisted_97 = { class: "title" }
const _hoisted_98 = { class: "description" }
const _hoisted_99 = { class: "flex-center" }
const _hoisted_100 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "icon-24",
  alt: "icons_white_ready_32px"
}, null, -1))
const _hoisted_102 = { class: "label" }
const _hoisted_103 = {
  key: 1,
  class: "flex-center"
}
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "icon-24",
  alt: "icons_white_warning_32px"
}, null, -1))
const _hoisted_105 = { class: "label" }
const _hoisted_106 = {
  key: 5,
  class: "box-step-three box-card p-24 mt-24"
}
const _hoisted_107 = { class: "title" }
const _hoisted_108 = { class: "description" }
const _hoisted_109 = { class: "flex-center" }
const _hoisted_110 = { class: "checkbox-set-up flex-center checked" }
const _hoisted_111 = { class: "flex-center" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "icon-24",
  alt: "icons_white_ready_32px"
}, null, -1))
const _hoisted_113 = { class: "label" }
const _hoisted_114 = {
  key: 6,
  class: "box-step-three box-card p-24 mt-24"
}
const _hoisted_115 = { class: "title" }
const _hoisted_116 = { class: "description" }
const _hoisted_117 = { class: "flex-center" }
const _hoisted_118 = { class: "checkbox-set-up flex-center checked" }
const _hoisted_119 = { class: "flex-center" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "icon-24",
  alt: "icons_white_ready_32px"
}, null, -1))
const _hoisted_121 = { class: "label" }
const _hoisted_122 = {
  key: 3,
  class: "box-step-four"
}
const _hoisted_123 = { class: "box-card section-box" }
const _hoisted_124 = { class: "header row fs-14 fw-700" }
const _hoisted_125 = { class: "flex-center" }
const _hoisted_126 = { class: "flex-mid center" }
const _hoisted_127 = {
  key: 0,
  class: "row time fs-16 fw-700"
}
const _hoisted_128 = { class: "flex-center" }
const _hoisted_129 = { class: "flex-mid" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "icon-16 mr-7 opa-05",
  alt: "icons_timer_20px"
}, null, -1))
const _hoisted_131 = {
  key: 1,
  class: "row time fs-16 fw-700"
}
const _hoisted_132 = { class: "flex-center" }
const _hoisted_133 = { class: "flex-mid" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "icon-16 mr-7 opa-05",
  alt: "icons_timer_20px"
}, null, -1))
const _hoisted_135 = {
  key: 2,
  class: "row time fs-16 fw-700"
}
const _hoisted_136 = { class: "flex-center" }
const _hoisted_137 = { class: "flex-mid" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "icon-16 mr-7 opa-05",
  alt: "icons_timer_20px"
}, null, -1))
const _hoisted_139 = {
  key: 3,
  class: "row time fs-16 fw-700"
}
const _hoisted_140 = { class: "flex-center" }
const _hoisted_141 = { class: "flex-mid" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "icon-16 mr-7 opa-05",
  alt: "icons_timer_20px"
}, null, -1))
const _hoisted_143 = {
  key: 4,
  class: "row time fs-16 fw-700"
}
const _hoisted_144 = { class: "flex-center" }
const _hoisted_145 = { class: "flex-mid" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "icon-16 mr-7 opa-05",
  alt: "icons_timer_20px"
}, null, -1))
const _hoisted_147 = { class: "box-card section-box advanced-options p-24 mt-36" }
const _hoisted_148 = { class: "title" }
const _hoisted_149 = { class: "mt-12 fs-14" }
const _hoisted_150 = { class: "mt-24" }
const _hoisted_151 = { class: "title" }
const _hoisted_152 = { class: "mt-16" }
const _hoisted_153 = { class: "mt-24" }
const _hoisted_154 = { class: "title" }
const _hoisted_155 = { class: "checkbox-primary mt-24" }
const _hoisted_156 = { class: "checkbox-style" }
const _hoisted_157 = { class: "mt-24" }
const _hoisted_158 = { class: "title" }
const _hoisted_159 = { class: "checkbox-primary mt-24" }
const _hoisted_160 = { class: "checkbox-style" }
const _hoisted_161 = { class: "mt-24" }
const _hoisted_162 = { class: "title" }
const _hoisted_163 = { class: "checkbox-primary mt-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backStep && _ctx.backStep(...args))),
          class: "btn-back"
        }, _hoisted_5),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("create.Create_new_assessment")), 1),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.form.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.form.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("create.Untitled_assessment")), 1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.step == 1 && !_ctx.isStartedTest)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.oneNextstep && _ctx.oneNextstep(...args))),
              class: _normalizeClass(["ml-16 btn btn-50", `${_ctx.btnNexstepOne ? 'btn-primary' : 'disable-true'}`])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("create.Next_Step")), 1),
              (_ctx.btnNexstepOne && _ctx.isLightColor)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : (_openBlock(), _createElementBlock("img", _hoisted_12))
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.step == 1 && _ctx.isStartedTest)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.oneNextstepStartedTest && _ctx.oneNextstepStartedTest(...args))),
              class: _normalizeClass(["ml-16 btn btn-50", `${_ctx.btnNexstepOne ? 'btn-primary' : 'disable-true'}`])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("create.Publish")), 1),
              _hoisted_13
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.step == 2)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.twoNextstep && _ctx.twoNextstep(...args))),
              class: _normalizeClass(["ml-16 btn btn-50", `${_ctx.btnNexstepTwo ? 'btn-primary' : 'disable-true'}`])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("create.Next_Step")), 1),
              (_ctx.btnNexstepTwo && _ctx.isLightColor)
                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                : (_openBlock(), _createElementBlock("img", _hoisted_15))
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.step == 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.threeNextstep && _ctx.threeNextstep(...args))),
              class: _normalizeClass(["ml-16 btn btn-50", `${_ctx.btnNexstepThree ? 'btn-primary' : 'disable-true'}`])
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("create.Next_Step")), 1),
              (_ctx.btnNexstepThree && _ctx.isLightColor)
                ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                : (_openBlock(), _createElementBlock("img", _hoisted_17))
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.step == 4 && _ctx.publishSubmitStatus)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.publishSubmit && _ctx.publishSubmit(...args))),
              class: "ml-16 btn btn-50 btn-primary"
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("create.Publish")), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "icon-24",
                  style: _normalizeStyle(`${_ctx.isLightColor ? 'filter: invert(1)' : ''}`),
                  alt: "icons_white_publish_24px"
                }, null, 4)
              ])
            ]))
          : (_ctx.step == 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("create.Publish")), 1),
                _hoisted_21
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gotoStep(1))),
              class: _normalizeClass(["step-box mx-auto", `${_ctx.btnNextStepCls(1)}`])
            }, [
              (_ctx.step > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, "1"))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(`mt-14 label ${_ctx.step == 1 ? 'show' : ''}`)
            }, _toDisplayString(_ctx.$t("create.Name_Assessment")), 3)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`flex-mid relative ${_ctx.step > 1 ? 'active' : ''}`)
        }, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gotoStep(2))),
              class: _normalizeClass(["step-box mx-auto", `${_ctx.btnNextStepCls(2)}`])
            }, [
              (_ctx.step > 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, "2"))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(`mt-14 label ${_ctx.step == 2 ? 'show' : ''}`)
            }, _toDisplayString(_ctx.$t("create.Select_Sections")), 3)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(`flex-mid relative ${_ctx.step > 2 ? 'active' : ''}`)
        }, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.gotoStep(3))),
              class: _normalizeClass(["step-box mx-auto", `${_ctx.btnNextStepCls(3)}`])
            }, [
              (_ctx.step > 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, "3"))
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(`mt-14 label ${_ctx.step == 3 ? 'show' : ''}`)
            }, _toDisplayString(_ctx.$t("create.Your_Culture_Model")), 3)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(`flex-mid relative ${_ctx.step > 3 ? 'active' : ''}`)
        }, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.gotoStep(4))),
              class: _normalizeClass(["step-box mx-auto", `${_ctx.btnNextStepCls(4)}`])
            }, " 4 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(`mt-14 label ${_ctx.step == 4 ? 'show' : ''}`)
            }, _toDisplayString(_ctx.$t("create.Review_and_Publish")), 3)
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.name) = $event)),
              onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onChangeFormName && _ctx.onChangeFormName(...args))),
              class: _normalizeClass(`input-44-0000000d ${_ctx.validateStyle(_ctx.validateForm.name)}`),
              placeholder: _ctx.$t('placeholder.Name_your_assessment'),
              type: "text"
            }, null, 42, _hoisted_46), [
              [_vModelText, _ctx.form.name]
            ]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.form.intendedfor,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.intendedfor) = $event)),
              placeholder: _ctx.$t('placeholder.What_is_this_assessment_for'),
              class: _normalizeClass(`input-44-0000000d select no-icon mt-24 ${_ctx.validateStyle(
            _ctx.validateForm.intendedfor
          )}`)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intendedforOptions, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item,
                    label: _ctx.$t(item),
                    value: _ctx.$t('optional.' + item)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("optional." + item)), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "class"]),
            _createVNode(_component_el_select, {
              modelValue: _ctx.form.langRequired,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.langRequired) = $event)),
              placeholder: _ctx.$t('create.Languages_required_to_support'),
              class: _normalizeClass(`input-44-0000000d select no-icon mt-24 tag-primary-color ${_ctx.validateStyle(
            _ctx.validateForm.langRequired
          )}`),
              multiple: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langRequired, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "class"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionListStepTwo, (section) => {
              return (_openBlock(), _createElementBlock("div", {
                key: section.keyValue,
                class: "box-card box-step-two"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("create." + section.title)), 1),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("div", null, _toDisplayString(section.timeDefault) + " " + _toDisplayString(_ctx.$t("create.min")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.description, (des, i2) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: des.label + i2,
                          class: _normalizeClass(des.class)
                        }, _toDisplayString(_ctx.$t("create." + des.label)) + " ", 3))
                      }), 128))
                    ]),
                    _hoisted_52,
                    (section.description_end)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.$t("create." + section.description_end)), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.onClickSection(section.keyValue)),
                    class: _normalizeClass(["ml-auto checkbox-section flex-mid", { checked: (_ctx.form.sections as any)[section.keyValue] }])
                  }, [
                    _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t("create.Select")), 1),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("create.Selected")), 1)
                    ])
                  ], 10, _hoisted_55)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            (_ctx.AI_ASSISTED_SETUP)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("create.Your_Core_Values")), 1),
                  _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("create.Define_your_organizational")), 1),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.coreValue,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.coreValue) = $event)),
                      placeholder: _ctx.$t('create.Quick_Select_or_Add'),
                      class: _normalizeClass(`input-44-0000000d select no-icon mt-24 tag-primary-color`),
                      style: {"height":"auto"},
                      multiple: "",
                      "allow-create": "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coreValueTags, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.label,
                            value: item.label
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setupByAI())),
                      class: _normalizeClass(["btn btn-44 btn-primary", `${_ctx.coreValueEnabled ? 'btn-primary' : 'disable-true'} ${
                _ctx.setupByAILoadingStatus.values_and_traits ||
                _ctx.setupByAILoadingStatus.OAIC_archetypes
                  ? 'disable-true'
                  : ''
              }`]),
                      style: _normalizeStyle(`width: ${_ctx.$t('lang_code') == 'th' ? '22' : '22'}rem`)
                    }, [
                      _hoisted_65,
                      _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t("create.Start_AI_Assisted_Setup")), 1)
                    ], 6),
                    _createElementVNode("div", {
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.proceedWithManualSetup && _ctx.proceedWithManualSetup(...args))),
                      class: "fc-primary link ml-32 fs-16"
                    }, _toDisplayString(_ctx.$t("create.Proceed_with_Manual_Setup")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.AI_ASSISTED_SETUP)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, null, 512))
              : _createCommentVNode("", true),
            (_ctx.form.sections.values_and_traits)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("create.Values_and_Traits")), 1),
                    _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t("create.Setup_your_company_values")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    (_ctx.setupByAILoadingStatus.values_and_traits)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t("create.Generate")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setUpValuesAndTraitsNewTab(_ctx.formId))),
                          class: _normalizeClass(["checkbox-set-up flex-center", { checked: _ctx.hasValuesAndTraits }])
                        }, [
                          (_ctx.hasValuesAndTraits)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                _hoisted_76,
                                _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t("create.Ready")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                _hoisted_79,
                                (_ctx.setupByAIStatus.values_and_traits)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, _toDisplayString(_ctx.$t("create.Pending_Review")), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_81, _toDisplayString(_ctx.$t("create.Set_up")), 1))
                              ]))
                        ], 2))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.sections.OAIC_archetypes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t("create.Culture_Profile")), 1),
                    _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.$t("create.Setup_your_culture_profile")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    (_ctx.setupByAILoadingStatus.OAIC_archetypes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _hoisted_87,
                          _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.$t("create.Generate")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setUpOAIC_ArchetypesNewTab(_ctx.formId))),
                          class: _normalizeClass(["checkbox-set-up flex-center", { checked: _ctx.hasOaicArchetypes }])
                        }, [
                          (_ctx.hasOaicArchetypes)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                _hoisted_90,
                                _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.$t("create.Ready")), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                _hoisted_93,
                                (_ctx.setupByAIStatus.OAIC_archetypes)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.$t("create.Pending_Review")), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.$t("create.Set_up")), 1))
                              ]))
                        ], 2))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.sections.acceptable_behaviors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.$t("create.Acceptable_Behaviors")), 1),
                    _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.$t("create.Setup_your_acceptable_behaviors")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("div", {
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setUpAcceptableBehaviorsNewTab(_ctx.formId))),
                      class: _normalizeClass(["checkbox-set-up flex-center", { checked: _ctx.hasAcceptableBehaviors }])
                    }, [
                      (_ctx.hasAcceptableBehaviors)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            _hoisted_101,
                            _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.$t("create.Ready")), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_103, [
                            _hoisted_104,
                            _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.$t("create.Set_up")), 1)
                          ]))
                    ], 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.sections.human_skills)
              ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.$t("create.Human_Skills")), 1),
                    _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.$t("create.No_set_up_required_to_assess_written")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", _hoisted_111, [
                        _hoisted_112,
                        _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.$t("create.Ready")), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.form.sections.work_style_identifier)
              ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t("create.Work_Style_Identifier")), 1),
                    _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t("create.No_set_up_required")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _hoisted_120,
                        _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.$t("create.Ready")), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.step == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.$t("create.SECTIONS")), 1),
                _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.$t("create.DURATION")), 1)
              ]),
              (_ctx.form.sections.values_and_traits)
                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                    _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.$t("create.Values_and_Traits")), 1),
                    _createElementVNode("div", _hoisted_129, [
                      _hoisted_130,
                      _createElementVNode("div", null, _toDisplayString(_ctx.extraTimeAdd + 5) + "’", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.sections.OAIC_archetypes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t("create.Culture_Profile")), 1),
                    _createElementVNode("div", _hoisted_133, [
                      _hoisted_134,
                      _createElementVNode("div", null, _toDisplayString(_ctx.extraTimeAdd + 5) + "’", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.sections.acceptable_behaviors)
                ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.$t("create.Acceptable_Behaviors")), 1),
                    _createElementVNode("div", _hoisted_137, [
                      _hoisted_138,
                      _createElementVNode("div", null, _toDisplayString(_ctx.extraTimeAdd + 5) + "’", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.sections.human_skills)
                ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                    _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.$t("create.Human_Skills")), 1),
                    _createElementVNode("div", _hoisted_141, [
                      _hoisted_142,
                      _createElementVNode("div", null, _toDisplayString(_ctx.extraTimeAdd + 10) + "’", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.form.sections.work_style_identifier)
                ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                    _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.$t("create.Work_Style_Identifier")), 1),
                    _createElementVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _createElementVNode("div", null, _toDisplayString(_ctx.extraTimeAdd + 5) + "’", 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.$t("create.Advanced_Options")), 1),
                _createElementVNode("div", _hoisted_149, _toDisplayString(_ctx.$t("create.Additional_configurations_to")), 1)
              ]),
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("div", _hoisted_151, _toDisplayString(_ctx.$t("create.Extra_Time")), 1),
                _createElementVNode("div", _hoisted_152, [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.extraTime,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.extraTime) = $event)),
                    class: "select-login e-input-52",
                    style: {"width":"164px"},
                    placeholder: _ctx.$t('create.Select')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: '0 ' + _ctx.$t('create.min'),
                        value: "0"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: '1 ' + _ctx.$t('create.min'),
                        value: "1"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: '2 ' + _ctx.$t('create.min'),
                        value: "2"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: '3 ' + _ctx.$t('create.min'),
                        value: "3"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: '4 ' + _ctx.$t('create.min'),
                        value: "4"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        label: '5 ' + _ctx.$t('create.min'),
                        value: "5"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_153, [
                _createElementVNode("div", _hoisted_154, _toDisplayString(_ctx.$t("create.Sharing_Results")), 1),
                _createElementVNode("div", _hoisted_155, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.sharingResults) = $event)),
                      type: "checkbox",
                      value: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.sharingResults]
                    ]),
                    _createElementVNode("span", _hoisted_156, _toDisplayString(_ctx.$t("create.Auto_send_assessment")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("div", _hoisted_158, _toDisplayString(_ctx.$t("create.Open_ended_Feedback")), 1),
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.openEndedQuestion) = $event)),
                      type: "checkbox",
                      value: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.openEndedQuestion]
                    ]),
                    _createElementVNode("span", _hoisted_160, _toDisplayString(_ctx.$t("create.Allow_respondents_to")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_161, [
                _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.$t("create.Redirect_respondents_to")), 1),
                _createElementVNode("div", _hoisted_163, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.redirectUrl) = $event)),
                    class: _normalizeClass(`input-44-0000000d ${_ctx.checkingItIsURL(
                  _ctx.form.redirectUrl
                )}`),
                    style: {"max-width":"40rem","font-size":"1.5rem"},
                    placeholder: "https://myculture.happily.ai/thank-you-for-submitting",
                    type: "text"
                  }, null, 2), [
                    [_vModelText, _ctx.form.redirectUrl]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}